export default "__VITE_ASSET__BsKs0RMq__"